// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","groupTitle":"ParametersGroupHeader__groupTitle--PU","text":"ParametersGroupHeader__text--Th","matches":"ParametersGroupHeader__matches--_y"};